/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DirectionControllerService {
    /**
     * @returns any Array of Direction model instances with selected fields
     * @throws ApiError
     */
    public static directionControllerGetAllDirections(): CancelablePromise<Array<any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v0/api/direction',
        });
    }
}
